module.exports = __webpack_public_path__ + "static/media/junagadh.cc04ca1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/junagadh.jpg
// module id = 1007
// module chunks = 0